import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POIDestinationStateFields from "@/components/POI/POIStateFields/POIDestinationStateFields/POIDestinationStateFields.vue";

export default {
  components: { POIStep, POIDestinationStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
